import { cn } from '@cobliteam/colib-ui/cn';
import { m } from 'motion/react';
import type { HTMLAttributes } from 'react';

interface SearchIconProps extends HTMLAttributes<HTMLDivElement> {
  isHovered: boolean;
}

const SearchIcon = ({ className, isHovered, ...props }: SearchIconProps) => (
  <div className={cn(className)} {...props}>
    <m.svg
      xmlns='http://www.w3.org/2000/svg'
      width={16}
      height={16}
      viewBox='0 0 24 24'
      fill='none'
      stroke='currentColor'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
      variants={{
        normal: { x: 0, y: 0 },
        animate: {
          x: [0, 0, -3, 0],
          y: [0, -4, 0, 0],
        },
      }}
      transition={{
        duration: 1,
        bounce: 0.3,
      }}
      animate={isHovered ? 'animate' : 'normal'}
    >
      <circle cx='11' cy='11' r='8' />
      <path d='m21 21-4.3-4.3' />
    </m.svg>
  </div>
);

export { SearchIcon };
